/**
 * PrimeReact 7.2 tooltips open on `mouseenter` and close on `mouseleave`.
 * On phones / tablets a tap fires `mouseenter` but no `mouseleave` until the
 * user taps somewhere else, so a button's tooltip (e.g. the icon-only
 * "I-130 Beneficiary Questionnaire" header button) stays open over the tabs.
 * After a tap on an element that can carry a tooltip, this sends it a
 * `mouseleave` a moment later: the tooltip shows when tapped, then hides.
 * Mouse users are not affected (no touch events).
 */
const TOOLTIP_TARGETS = '.p-button, [data-pr-tooltip]';
const HIDE_AFTER_MS = 1500;

const timers = new WeakMap<Element, number>();

export function initTouchTooltipAutoHide(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  const w = window as any;
  if (w.__touchTooltipAutoHide) {
    return;
  }
  w.__touchTooltipAutoHide = true;

  document.addEventListener(
    'touchend',
    (event: TouchEvent) => {
      const start = event.target as Element | null;
      const target = start && start.closest ? start.closest(TOOLTIP_TARGETS) : null;
      if (!target) {
        return;
      }
      const previous = timers.get(target);
      if (previous) {
        window.clearTimeout(previous);
      }
      timers.set(
        target,
        window.setTimeout(() => {
          timers.delete(target);
          target.dispatchEvent(new MouseEvent('mouseleave', { bubbles: false }));
        }, HIDE_AFTER_MS),
      );
    },
    { capture: true, passive: true },
  );
}
